import { Flex } from '@chakra-ui/react';
import { Card, CardContent } from '@mesh.ai/rabbit';
import { L3_PATHS } from 'Deer/constants/routes';
import { useRouteToMyTeamLevels } from 'Deer/hooks/useRouteToL3';
import { DeerBreadcrumbs } from 'Deer/intent/components/Layout/Layout';
import { useHistory } from 'react-router-dom';

import { ArrowBack } from 'assets/assetsV1/iconComponents';

import { isNetchexLogin } from 'constants/netChexConstants';

import { Button } from 'uiToolkitV1/Button';
import { TextHeader2 } from 'uiToolkitV1/Typography';

import { EDIT_SCREEN_TITLE } from './constant';

const CardWithBackButton = ({ title, goBack, revieweeName }) => (
  <Card
    style={{
      marginBottom: '12px',
      padding: '12px',
    }}
  >
    <CardContent>
      <Flex flexDirection="row" alignItems="center" gap="12px">
        <Button
          StartIcon={ArrowBack}
          variant="tertiary"
          onClick={goBack}
          startIconProps={{ color: '#666666 !important' }}
          style={{ padding: '0px' }}
        />
        <TextHeader2 bold>
          {revieweeName}: {title}
        </TextHeader2>
      </Flex>
    </CardContent>
  </Card>
);

const Header = ({ revieweeName }) => {
  const history = useHistory();
  const { l1Module, teamType } = useRouteToMyTeamLevels();
  const L1displayName = teamType === 'directReports' ? 'Direct Team' : 'Skip Team';
  const urlToRevieweeListPage = L3_PATHS[l1Module][teamType].review.actionPlan;
  const urlToReviewsOverview = L3_PATHS[l1Module][teamType].overview.myTeamOverview;
  const goBackToRevieweeListPage = () => {
    history.push(urlToRevieweeListPage);
  };

  return (
    <>
      {!isNetchexLogin && (
        <DeerBreadcrumbs
          breadcrumbs={{
            items: [
              {
                label: L1displayName,
                to: urlToReviewsOverview,
              },
              {
                label: 'Reviews',
                to: urlToRevieweeListPage,
              },
            ],
            page: {
              label: `Post review action plan for ${revieweeName}`,
              to: '',
            },
          }}
        />
      )}
      <CardWithBackButton title={EDIT_SCREEN_TITLE} goBack={goBackToRevieweeListPage} revieweeName={revieweeName} />
    </>
  );
};

export default Header;
